<template>
  <PageLoading :is-loading="isLoading"></PageLoading>
  <SideComponent @scrollto="scroll"></SideComponent>
  <div class="container" ref="viewBox">
    <div class="header-container">
      <HeaderVR />
    </div>
    <div class="content">
      <div class="news-container">
        <section class="news-wrapper">
          <div class="news-left">
            <span class="text-style">本周精选</span>
          </div>
          <div class="news-right">
            <Loading :is-loading="isListLoading"></Loading>
            <div
              v-for="item in list"
              :key="item.id"
              class="news-item"
              @click="toDetail(item)"
            >
              <div class="news-item-outer">
                <div class="img-outer">
                  <img :src="item.teaserImage || item.thumb" oncontextmenu="return false" :alt="item.title" />
                </div>
                <div class="news-title">
                  <span>{{ item.title }}</span>
                  <p v-if="item.description" class="weekly-pick-desc">{{ item.description }}</p>
                </div>
              </div>
            </div>
            <div v-if="!isListLoading && list.length === 0" class="weekly-pick-empty">暂无本周精选内容</div>
          </div>
        </section>
        <div class="loadmore">
          <Loading :is-loading="isListLoading"></Loading>
          <span class="more" @click="loadMore" v-if="!nomore && list.length > 0">加载更多</span>
          <span class="end" v-if="nomore && list.length > 0">- 已经到底了 -</span>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import weekly_pick_list from './weekly_pick_list_controller';
export default weekly_pick_list;
</script>

<style src="@/assets/css/news.css" scoped></style>
<style scoped>
.weekly-pick-desc {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #9b9b9b;
  font-weight: normal;
}
.weekly-pick-empty {
  padding: 40px 0;
  text-align: center;
  color: #999;
}
</style>
